// extracted by mini-css-extract-plugin
export default {"container":"LastMatchesResults_container__thhup","win":"LastMatchesResults_win__dfwI1","lose":"LastMatchesResults_lose__JUYXw","draw":"LastMatchesResults_draw__Eo65O"};